'use strict';
import {applyDefaultReduxListComponentOptions} from '../../core-utilities/redux/ReduxListContainer';
import {SYNC_PATH} from '../../core-utilities/rx-utils';
import {getChatSubscribers} from '../reducers/state';
import {buildPeopleList, REDUX_OPTIONS} from '../../personnel/redux/peopleConfig';
import {CHAT_SUBSCRIBERS_LIST_PREFIX} from './state';

/** @type {ReduxList} */
export const reduxList = buildPeopleList({
  prefix: CHAT_SUBSCRIBERS_LIST_PREFIX,
  getState: getChatSubscribers,
  listPath: parentId => `chat-channels/${parentId}/subscribers`,
  listSyncPath: parentId => `chat-channels/${parentId}/subscribers/${SYNC_PATH}`,
  useDelete: false,
});

export const componentOptions = applyDefaultReduxListComponentOptions(reduxList.options, {
  ...REDUX_OPTIONS,
  excludeFilterModalOptions: true,
  useInitFilter: true,
});



// WEBPACK FOOTER //
// ./src/js/comments/redux/chatSubscriberList.js